import { render, staticRenderFns } from "./custom-footer.vue?vue&type=template&id=54c3e445"
import script from "./custom-footer.vue?vue&type=script&lang=js"
export * from "./custom-footer.vue?vue&type=script&lang=js"
import style0 from "./custom-footer.vue?vue&type=style&index=0&id=54c3e445&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports